import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "../css/style.css";
import logo from "../assets/image/rccglogo.webp";

export default function ResetPassword() {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const inputRefs = useRef([]);
  const navigate = useNavigate();
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    const storedEmail = localStorage.getItem("resetEmail");
    if (storedEmail) {
      setEmail(storedEmail);
    } else {
      navigate("/forgot-password", { replace: true });
    }

    return () => {
      isMounted.current = false;
    };
  }, [navigate]);

  const handleChange = (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    if (!value) return;

    const newOtp = [...otp];
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);

    if (index < 5) inputRefs.current[index + 1]?.focus();
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      if (!otp[index] && index > 0) inputRefs.current[index - 1]?.focus();
      newOtp[index] = "";
      setOtp(newOtp);
    }
  };

  const handleVerifyOtp = async () => {
    if (loading) return;

    const code = otp.join("");
    if (code.length !== 6) {
      toast.error("Please enter the full 6-digit OTP.", { theme: "colored" });
      return;
    }

    setLoading(true);
    try {
      const TEST_BASE_URL = process.env.REACT_APP_BASE_URL;
      const res = await fetch(`${TEST_BASE_URL}/auth/verify-reset-password-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp: code }),
      });

      const data = await res.json();

      if (!res.ok) {
        const msg = data.message?.toLowerCase().includes("invalid")
          ? "Invalid OTP. Please check and try again."
          : data.message || "OTP verification failed.";
        toast.error(msg, { theme: "colored" });
        setLoading(false);
        return;
      }

      // Save OTP and email to localStorage for password reset
      localStorage.setItem("verifiedEmail", email);
      localStorage.setItem("verifiedOtp", code);

      toast.success("OTP verified successfully!", { theme: "colored" });

      setTimeout(() => {
        navigate("/new-password", { replace: true });
      }, 1500);
    } catch (err) {
      console.error(err);
      toast.error("Network error — please try again.", { theme: "colored" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="login">
        <div className="containerfluid">
          <div className="row loginrow">
            <div className="col-md-6">
              <div className="loginbg">
                <img src={logo} alt="RCCG Logo" />
                <h5 className="py-5">Welcome to RCCG New Beginning Chapel, Bournemouth, UK</h5>
                <p className="text-white">
                  RCCG Bournemouth Membership Portal has been built to create a
                  community where the church members can interact with each
                  other seamlessly.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card resetcard">
                <h5>Reset Password</h5>
                <p>
                  We have sent you a code at <b>{email || "your email address"}</b>
                </p>

                <div className="otp-inputs">
                  {otp.map((_, i) => (
                    <input
                      key={i}
                      type="tel"
                      maxLength="1"
                      ref={(el) => (inputRefs.current[i] = el)}
                      value={otp[i]}
                      onChange={(e) => handleChange(e, i)}
                      onKeyDown={(e) => handleKeyDown(e, i)}
                      className="otp-box"
                    />
                  ))}
                </div>

                <p>
                  Didn't receive a code?{" "}
                  <a href="/forgot-password" className="text-primary">
                    <u>Click to resend</u>
                  </a>
                </p>

                <button
                  className="btn verify-btn mt-3"
                  onClick={handleVerifyOtp}
                  disabled={loading}
                >
                  {loading ? "Verifying..." : "Verify OTP"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer position="top-right" autoClose={1500} />
    </>
  );
}
